var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nearby-wrapper"},[_c('div',{staticClass:"top"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-center"}})]),_vm._v(" "),_c('h2',[_vm._v("\n      "+_vm._s(_vm.$t('components.nearby_businesses.near'))+" "+_vm._s(_vm.city.label)+"\n    ")])]),_vm._v(" "),_c('nearby-business-slider',{attrs:{"businesses":_vm.businessesList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }